const env = process.env;

export const CHECK_ACCESS_INTERVAL_MS = +(env.CHECK_ACCESS_INTERVAL_MS || 1000);
export const GRAPHQL_SERVER_SUBSCRIPTION_URL = String(env.REACT_APP_GRAPHQL_SERVER_SUBSCRIPTION_URL) || '';
export const GRAPHQL_SERVER_URL = String(env.REACT_APP_GRAPHQL_SERVER_URL) || '';
export const BUCLOUD_SERVER_URL = String(env.REACT_APP_BUCLOUD_SERVER_URL) || '';
export const ENGRAIN_API_KEY = String(env.REACT_APP_ENGRAIN_API_KEY) || 'pbENzYeiDV0pkCMnyMQjgqGIINUuZtaJ';
export const REALPAGE_EULA_URL = 'https://www.realpage.com/smart-building-eula/';
export const REALPAGE_PATENT_MARKING = 'https://www.realpage.com/legal/patent-marking/';
export const REALPAGE_PRIVACY_POLICY_URL = 'https://www.realpage.com/privacy-policy/';
